import c from 'classnames';
import { Button } from '../Button';
import { Typography } from '../Typography';
import styles from './FullBanner.module.css';
import { FullBannerProps, SizeVariantsValue } from './types/FullBanner.types';

const sizesVariants: Record<
  NonNullable<FullBannerProps['size']>,
  SizeVariantsValue
> = {
  sm: {
    title: 'heading-s',
    content: 'label',
    actionSize: 'small',
  },
  md: {
    title: 'heading-s',
    content: 'caption',
    actionSize: 'small',
  },
  lg: {
    title: 'subheading',
    content: 'body-s',
    actionSize: 'medium',
  },
  'inside-card': {
    title: 'heading-s',
    content: 'label',
    actionSize: 'small',
  },
};

export function FullBanner({
  title,
  content,
  color,
  icon,
  border,
  size = 'md',
  className,
  actionClassName,
  contentClassName,
  iconClassName,
  iconContainerClassName,
  action,
  children,
  onClose,
  isClosed,
}: FullBannerProps) {
  if (isClosed) return null;

  const colorStyles: Record<FullBannerProps['color'], string> = {
    purple: styles.purple,
    orange: styles.orange,
    lightPurple: styles.lightPurple,
  };

  return (
    <div
      className={c(
        styles.container,
        border && styles.border,
        colorStyles[color],
        styles[size],
        className,
      )}
    >
      {icon && (
        <div className={c(styles.iconContainer, iconContainerClassName)}>
          {icon({
            className: c(styles.icon, colorStyles[color], iconClassName),
          })}
        </div>
      )}
      <div className={styles.textsContainer}>
        <Typography
          variant={sizesVariants[size].title}
          className={styles.title}
        >
          {title}
        </Typography>

        <Typography
          variant={sizesVariants[size].content}
          className={c(styles.content, contentClassName)}
        >
          {content}
        </Typography>
        {children}
      </div>
      {onClose ? (
        <Button
          variant='text'
          iconNameRight='closeSm'
          onClick={onClose}
          className={styles.closeButton}
        />
      ) : null}
      {action ? (
        <Button
          className={c(styles.action, actionClassName)}
          label={action.label}
          onClick={action.onClick}
          size={sizesVariants[size].actionSize}
          color='white'
        />
      ) : null}
    </div>
  );
}
